import React, { useEffect, useState } from 'react';
import DataService from "../../../services/data.service";
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { useNotifications } from '../../../contexts/notificationContext';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import ProjectType_Popup_AddWorkflowDefinition from '../Popups/ProjectType_popup_AddWorkflowDefinition';

interface Props {
    projectTypeId: number
}

const ProjectType_tab_WorkflowDefinitions: React.FC<Props> = ({ projectTypeId }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [projectTypeId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/WorkflowDefinitionProjectTypes/ByProjectType/' + projectTypeId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/WorkflowDefinitionProjectTypes/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'workflowDefinitionId', visible: false },
        { title: 'Name', dataProp: 'workflowDefinition.name', sort: 'asc' },
        { title: 'Description', dataProp: 'workflowDefinition.description' },
    ];
    if (isAuthorizedForItemType(ApplicationFunctions.EditProjectType, projectTypeId)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtProjectTypeWorkflowDefinitions'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Workflow definition'
                navigateUrl='/plm/workflowsetup/workflow/'
            />
            {showPopup && <ProjectType_Popup_AddWorkflowDefinition projectTypeId={projectTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default ProjectType_tab_WorkflowDefinitions;